import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Services.css';

const Services = () => {
  const { t } = useLanguage();

  const skills = t.services.skills;

  return (
    <div className="sora-special-box" id="section-2">
      <div className="special-wrap row">
        <div className="special-title">
          <h4>
            {t.services.title.replace(/\s*\.{3}\s*$/, '')} <span style={{ color: 'red' }}>... {t.services.titleHighlight}</span>
          </h4>
        </div>
        <div style={{ clear: 'both' }} />

        <div className="skills">
          <dl>
            {skills.map((skill, index) => (
              <React.Fragment key={index}>
                <dt>
                  <p className="skills-text">{skill.label}</p>
                </dt>
                <dd className={`skill-bar skill-bar-${index + 1}`}>
                  <div className="skill-percent" data-percent={skill.percent} style={{ width: `${skill.percent}%` }} />
                </dd>
              </React.Fragment>
            ))}
          </dl>
        </div>

        <div className="skill-details">
          <div className="special-tiles" data-wow-delay="0s">
            <span className="special-icons">
              <i aria-hidden="true" className="fa fa-heart-o" style={{ position: 'absolute' }} />
            </span>
            <span className="special-content">
              <h6 className="special-heading" style={{ color: '#0925E0' }}>
                {t.services.aboutTitle}
              </h6>
              <p className="special-text">
                <b>{t.services.aboutText}</b>
              </p>
            </span>
          </div>
        </div>

        <div style={{ clear: 'both' }} />
      </div>
    </div>
  );
};

export default Services;
